import { Injectable } from '@angular/core';
import { Routes } from '@angular/router';
import { routes } from 'src/app/core/models/routes';

@Injectable({
    providedIn: 'root'
})
export class RokezzzPathService {
    public getPath(value: string | undefined): string | undefined {
        if (!value) {
            return undefined;
        }

        return this.findPathForTokenRecursive(value, routes) || '/';
    }

    private findPathForTokenRecursive(
        token: string | undefined,
        routes: Routes,
        parentPath: string = ''
    ): string | undefined {
        for (const route of routes) {
            let fullPath: string = parentPath + (route.path ? '/' + route.path : '');

            if (route.data && route.data['path'] === token) {
                fullPath = fullPath.replace(/\/:[^\/]+/g, '');

                return fullPath;
            }

            if (route.children) {
                const foundPath: string | undefined = this.findPathForTokenRecursive(token, route.children, fullPath);

                if (foundPath) {
                    return foundPath;
                }
            }
        }

        return undefined;
    }
}
